module.exports = __webpack_public_path__ + "img/logo_min.20aab4fd.png";